import styled from 'styled-components';

export const StyledScrambleSpan = styled.span`
    color: #fff;
`;
